import Model, { attr, belongsTo } from '@warp-drive/legacy/model';
import type UserModel from './user.ts';
import { Type } from '@warp-drive/core-types/symbols';

export default class AuthenticationLogModel extends Model {
  @attr declare identity: string;
  @attr declare ipAddress: string;
  @attr declare loginAttemptStatus: string;
  @attr declare createdAt: string;

  @belongsTo('user', { async: false, inverse: null })
  declare user: UserModel;

  [Type] = 'authentication-log' as const;
}
